import React from "react";
import { useNavigate } from "react-router-dom";

const TopToolbar = () => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate("/db"); // 導航到 /db 路由
  };

  return (
    <div style={styles.toolbar}>
      <button onClick={handleBackToDashboard} style={styles.button}>
        Back to Dashboard
      </button>
    </div>
  );
};

const styles = {
  toolbar: {
    display: "flex",
    justifyContent: "flex-start",
    padding: "10px 20px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default TopToolbar;